var _classCallCheck = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/admin/jenkins/workspace/mggroupsa_creditos-react_master@2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _debug = require('debug');

var debug = _debug('winston-aws-cloudwatch:Queue');

var Queue =
/*#__PURE__*/
function () {
  "use strict";

  function Queue() {
    _classCallCheck(this, Queue);

    this._contents = [];
  }

  _createClass(Queue, [{
    key: "push",
    value: function push(item) {
      debug('push', {
        item: item
      });

      this._contents.push(item);
    }
  }, {
    key: "head",
    value: function head(num) {
      debug('head', {
        num: num
      });
      return this._contents.slice(0, num);
    }
  }, {
    key: "remove",
    value: function remove(num) {
      debug('remove', {
        num: num
      });

      this._contents.splice(0, num);
    }
  }, {
    key: "size",
    get: function get() {
      return this._contents.length;
    }
  }]);

  return Queue;
}();

module.exports = Queue;